(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kjretail-product-technical"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-kjt-technical-section]');
    if (!sections.length) return;

    const resetInitialLightboxZoom = (dialog) => {
      dialog.querySelectorAll('drag-zoom-wrapper.product-media__drag-zoom-wrapper').forEach((wrapper) => {
        wrapper.style.setProperty('--drag-zoom-scale', '1');
        wrapper.style.setProperty('--drag-zoom-translate-x', '0px');
        wrapper.style.setProperty('--drag-zoom-translate-y', '0px');
      });
    };

    const scheduleInitialLightboxFit = () => {
      [0, 120, 360].forEach((delay) => {
        window.setTimeout(() => {
          document.querySelectorAll('dialog[open]').forEach(resetInitialLightboxZoom);
        }, delay);
      });
    };

    document.querySelectorAll('dialog').forEach((dialog) => {
      const observer = new MutationObserver(() => {
        if (dialog.open) scheduleInitialLightboxFit();
      });
      observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      if (dialog.open) scheduleInitialLightboxFit();
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('media-gallery button')) scheduleInitialLightboxFit();
    }, true);

    const normalizeLegacyDescription = () => {
      document.querySelectorAll('rte-formatter').forEach((description) => {
        const headings = [...description.querySelectorAll('h2')];
        const configurationHeading = headings.find(
          (heading) => heading.textContent.trim() === 'Configuration Specifications'
        );

        if (configurationHeading) {
          configurationHeading.hidden = true;
          const configurationTable = configurationHeading.nextElementSibling;
          if (configurationTable && configurationTable.tagName !== 'H2') {
            configurationTable.hidden = true;
          }
        }

        const performanceHeading = headings.find(
          (heading) => heading.textContent.trim() === 'Performance Data'
        );
        const performanceCopy = performanceHeading?.nextElementSibling;
        if (performanceCopy && /media gallery/i.test(performanceCopy.textContent)) {
          const targetId = sections[0].getAttribute('aria-labelledby');
          performanceCopy.textContent =
            'Official T-MOTOR test reports, thrust data, and performance charts are shown for the selected configuration below. Match the exact KV, voltage, propeller, and test conditions.';

          if (targetId) {
            const link = document.createElement('a');
            link.href = `#${targetId}`;
            link.textContent = ' View selected-configuration data.';
            performanceCopy.append(link);
          }
        }
      });
    };

    const showVariant = (section, variantId) => {
      if (!variantId) return;
      section.querySelectorAll('[data-kjt-technical-variant]').forEach((panel) => {
        panel.hidden = panel.dataset.kjtTechnicalVariant !== String(variantId);
      });
    };

    document.addEventListener('variant:update', (event) => {
      const variantId = event.detail?.resource?.id;
      const productId = event.detail?.data?.productId;
      sections.forEach((section) => {
        if (productId && section.dataset.productId !== String(productId)) return;
        showVariant(section, variantId);
      });
    });

    window.addEventListener('popstate', () => {
      const variantId = new URL(window.location.href).searchParams.get('variant');
      sections.forEach((section) => showVariant(section, variantId));
    });

    normalizeLegacyDescription();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kjretail-tmotor-esc-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tme-catalog]');
    if (!root) return;

    const buttons = [...root.querySelectorAll('[data-tme-filter]')];
    const lines = [...root.querySelectorAll('[data-tme-line]')];
    const status = root.querySelector('[data-tme-status]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.tmeFilter;
        let visible = 0;
        buttons.forEach((candidate) => candidate.setAttribute('aria-pressed', String(candidate === button)));
        lines.forEach((line) => {
          const filters = (line.dataset.filters || '').split(' ');
          const show = filter === 'all' || filters.includes(filter);
          line.hidden = !show;
          if (show) visible += line.querySelectorAll('[data-tme-product]').length;
        });
        if (status) status.textContent = `Showing ${visible} ${filter === 'all' ? '' : filter.toUpperCase() + ' '}products`;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
